<template>
  <div>
    <v-img
      :src="require('../assets/infrastructure.png')"
      style="position: absolute; right: 0px; opacity: 0.08"
    />
    <v-list class="grey lighten-4" rounded min-height="100%">
      <template v-for="(item, i) in items">
        <v-list-item :key="i" link @click="$router.push(item.path, () => {})">
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
            <v-list-item-subtitle>{{ item.subTitle }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </div>
</template>

<script>
export default {
  name: "Home",
  data: function() {
    return {
      items: [
        {
          icon: "description",
          title: "Pedidos",
          subTitle: "Gerencie seus pedidos",
          path: "/pedidos"
        },
        {
          icon: "supervisor_account",
          title: "Clientes",
          subTitle: "Gerencie seus clientes",
          path: "/clientes"
        },
        {
          icon: "store",
          title: "Produtos",
          subTitle: "Catálogo de produtos",
          path: "/produtos"
        }
      ]
    };
  }
};
</script>
